import React, { Component, Fragment } from "react";
import ResultBefore from "./ResultBefore";
import ResultAfter from "./ResultAfter";
import PrintTest from "./PrintTest";

class Preview extends Component {
  render() {
    const { dotsFirstStep, dotsSecondStep, cVisible } = this.props;
    return (      
        <div className="row">

            {!cVisible && 
                <Fragment>
              <ResultBefore dotsFirstStep={dotsFirstStep} />                     

                 
              <ResultAfter dotsSecondStep={dotsSecondStep} />
              </Fragment>

            }
            
              {cVisible && <PrintTest />}
          
        </div>
      
    );
  }
}

export default Preview;
